import { getOfficeReviews } from './GetOfficeReviews';
import { getOfficeReviewByShift } from './GetOfficeReviewByShift';
import { deleteOfficeReview } from './DeleteOfficeReview';

/**
 * Office Reviews Service
 * Provides business logic layer for office review operations
 */
export const OfficeReviewsService = {
  getOfficeReviews,
  getOfficeReviewByShift,
  deleteOfficeReview,
};
